import { useSelector } from "react-redux";

import { getLocation } from "../../ducks/location/selectors";

import { RoutePanelName } from "../../appConfig/types";

export const useIsDashboard = (): boolean => {
  const { payload } = useSelector(getLocation);

  return [RoutePanelName.Dashboard, RoutePanelName.Presentation].includes(payload.panel);
};
